import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyBIYNduCPfu5bUNotdyHWZT7vzHZrg1G1s",
  authDomain: "portfolio-formdata.firebaseapp.com",
  databaseURL: "https://portfolio-formdata-default-rtdb.firebaseio.com",
  projectId: "portfolio-formdata",
  storageBucket: "portfolio-formdata.firebasestorage.app",
  messagingSenderId: "169779029723",
  appId: "1:169779029723:web:314cc8c54af7493aa50efe"
};
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);